import { render } from "./ContactFlag.vue?vue&type=template&id=59a8cda0"
import script from "./ContactFlag.vue?vue&type=script&lang=js"
export * from "./ContactFlag.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__